"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GridProducts = void 0;

var _styles = require("./styles");

var _GridItem = require("../../molecules/GridItem");

var _HeaderItem = require("../../molecules/HeaderItem");

var _RowItem = require("../../molecules/RowItem");

var _jsxRuntime = require("react/jsx-runtime");

var GridProducts = function GridProducts(_ref) {
  var _ref$products = _ref.products,
      products = _ref$products === void 0 ? [] : _ref$products,
      _ref$columnsArray = _ref.columnsArray,
      columnsArray = _ref$columnsArray === void 0 ? [] : _ref$columnsArray,
      _ref$gridView = _ref.gridView,
      gridView = _ref$gridView === void 0 ? true : _ref$gridView,
      chkOnChange = _ref.chkOnChange,
      _ref$selected = _ref.selected,
      selected = _ref$selected === void 0 ? [] : _ref$selected,
      chkChecked = _ref.chkChecked,
      checkAll = _ref.checkAll,
      chkCheckedAll = _ref.chkCheckedAll,
      onGridClick = _ref.onGridClick;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Container, {
    children: gridView ? products === null || products === void 0 ? void 0 : products.map(function (_ref2, i) {
      var gridElement = _ref2.gridElement,
          product = _ref2.product,
          id = _ref2.id;
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_GridItem.GridItem, {
        id: id,
        index: i,
        product: product,
        gridElement: gridElement,
        chkOnChange: chkOnChange,
        onGridClick: gridView ? null : onGridClick,
        selected: selected,
        chkChecked: chkChecked
      }, i);
    }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "table-view",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_HeaderItem.HeaderItem, {
        columnsArray: columnsArray,
        checkAll: checkAll,
        chkCheckedAll: chkCheckedAll
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_RowItem.RowItem, {
        productsArray: products,
        chkOnChange: chkOnChange,
        onGridClick: onGridClick,
        chkChecked: chkChecked
      })]
    })
  });
};

exports.GridProducts = GridProducts;